import { Quill } from "vue-quill-editor";
import "quill-emoji/dist/quill-emoji.css"; // 引入样式文件
import quillEmoji from "quill-emoji";
Quill.register("modules/quillEmoji", quillEmoji); //将emoji插件注册进富文本
// 注册 文本高亮
var Inline = Quill.import("blots/inline");
class HighlightBlot extends Inline {
  static create(value) {
    let node = super.create();
    node.style.backgroundColor = value;
    return node;
  }
  static formats(node) {
    return node.style.backgroundColor;
  }
}
HighlightBlot.blotName = "selection-highlight";
HighlightBlot.tagName = "span";
HighlightBlot.className = "quill-selection-highlighted-text";
Quill.register(HighlightBlot);

// 注册敏感词、错误字词高亮
class dangerLightBlot extends Inline {
  static create(value) {
    let node = super.create();
    node.style.backgroundColor = value;
    return node;
  }
  static formats(node) {
    return node.style.backgroundColor;
  }
}
dangerLightBlot.blotName = "danger-highlight";
dangerLightBlot.tagName = "span";
dangerLightBlot.className = "quill-danger-highlighted-text";
Quill.register(dangerLightBlot);

// 注册引用资料波浪线
class referenceLightBlot extends Inline {
  static create(value) {
    let node = super.create();
    node.style.backgroundColor = value;
    return node;
  }
  static formats(node) {
    return node.style.backgroundColor;
  }
}
referenceLightBlot.blotName = "reference-highlight";
referenceLightBlot.tagName = "span";
referenceLightBlot.className = "quill-reference-highlighted-text";
Quill.register(referenceLightBlot);